import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_crm-news-hub/artifacts/srv2lps9_ChatGPT%20Image%20Apr%202%2C%202026%2C%2010_47_10%20AM.png";

const AdminLogin = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate("/admin", { replace: true });
    }
  }, [user, loading, navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-cfc-primary flex items-center justify-center">
        <div className="text-cfc-cream text-xl font-heading">Loading...</div>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen bg-cfc-primary flex items-center justify-center p-4"
      data-testid="admin-login-page"
    >
      <Card className="w-full max-w-md bg-white rounded-sm">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <img src={LOGO_URL} alt="Commonwealth FC" className="h-24 w-auto" />
          </div>
          <CardTitle className="font-heading text-2xl text-cfc-primary">
            ADMIN LOGIN
          </CardTitle>
          <CardDescription className="text-cfc-text-muted">
            Sign in to access the CRM dashboard
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-6">
          <Button 
            onClick={handleGoogleLogin}
            className="w-full bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 font-medium py-6"
            data-testid="google-login-btn"
          >
            <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Sign in with Google
          </Button>
          
          <p className="text-center text-sm text-cfc-text-muted mt-6">
            Only authorized administrators can access this area
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
